import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -16","key":"svg-0"}]]

/**
 * IconColumns1
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29sdW1ucy0xIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDRhMSAxIDAgMCAxIDEgLTFoMTJhMSAxIDAgMCAxIDEgMXYxNmExIDEgMCAwIDEgLTEgMWgtMTJhMSAxIDAgMCAxIC0xIC0xbDAgLTE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/columns-1
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconColumns1 = createReactComponent('outline', 'columns-1', 'Columns1', __iconNode);

export default IconColumns1;